
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/assets/partnerships/[project]",
      function () {
        return require("private-next-pages/[locale]/assets/partnerships/[project].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/assets/partnerships/[project]"])
      });
    }
  